import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { DashboardService } from "./services/dashboard.service";
import { forkJoin } from "rxjs";
import { DataSourceModel } from "@models";
import { DatasourceSummaryStatsModel } from "./models/datasource-summary-stats.model";
import { CrossMatchSummaryStatsModel } from "@app/dashboard/models/crossmatch-summary-stats.model";
import { DataSourceService } from "@services";

@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public isLoading = true;
  public isCrossMatchLoading = false;
  public dataSources: DataSourceModel[] = [];
  public allDataSourcesSummaryStats: DatasourceSummaryStatsModel[] = [];
  public crossMatchSummaryStats: CrossMatchSummaryStatsModel[] = [];
  public selectedDatasourceId = 0;
  
  constructor(
      private _datasourceService: DataSourceService,
      private _dashboardService: DashboardService) { }

  ngOnInit() {
    forkJoin(this._datasourceService.getDataSources(), this._dashboardService.getAllDataSourcesSummary())
        .pipe(finalize(() => this.isLoading = false))
        .subscribe(([dataSources, summary]) => {
          this.dataSources = dataSources.filter(d => summary.some(s => s.dataSourceCode === d.name ));
          this.allDataSourcesSummaryStats = summary;
          this.onDataSourceSelect(this.dataSources[0].id);
        });
  }
  
  public onDataSourceSelect(datasourceId: number): void {
    this.isCrossMatchLoading = true;
    this.selectedDatasourceId = datasourceId;
    
    this._dashboardService.getCrossMatchSummary(datasourceId)
        .pipe(finalize(() => this.isCrossMatchLoading = false))
        .subscribe((response: CrossMatchSummaryStatsModel[]) => {
            this.crossMatchSummaryStats = response;
        });
  }
}
